import { Button } from "@material-ui/core";
import { useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';

export function GoogleLoginCustomButton({ onSuccess, onError }) {
  const codeClientRef = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    /* global google */
    if (!window.google) return;

    codeClientRef.current = google.accounts.oauth2.initCodeClient({
      client_id: "1007810679982-qog56s74f8o4ths4e8df8leem49g5l3f.apps.googleusercontent.com",
      scope: "openid email profile",
      ux_mode: "popup",
      callback: (response) => {
        if (response.error) {
          onError?.(response);
          return;
        }

        // Acá ya no recibís response.credential
        // Recibís un authorization code
        onSuccess({
          code: response.code,
          origen: "google_with_code",
        });
      },
      error_callback: (error) => {
        onError?.(error);
      },
    });
  }, [onSuccess, onError]);

  const handleClick = () => {
    codeClientRef.current?.requestCode();
  };

  return (
    <Button variant="contained" color="primary" startIcon={<GoogleIcon />} className={classes.buttonGoogle} onClick={handleClick}>
      Iniciar Sesión con Google
    </Button>
  );
}


const GoogleIcon = props => {
  const { className } = props;
  return (
      <svg
          className={className}
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <path
              d="M13.2641 10.7107V15.678H20.485C19.5407 18.6875 16.9747 20.8416 13.2641 20.8416C8.84539 20.8416 5.26347 17.3303 5.26347 13C5.26347 8.6697 8.84539 5.1584 13.2641 5.1584C15.2507 5.1584 17.0648 5.8721 18.4639 7.0473L22.1957 3.3891C19.8391 1.2844 16.7041 0 13.2641 0C5.93848 0 0 5.8201 0 13C0 20.1799 5.93848 26 13.2641 26C24.3984 26 26.8558 15.795 25.7643 10.7276L13.2641 10.7107Z"
              fill="white"
          />
      </svg>
  );
};

const useStyles = makeStyles((theme) => ({
  buttonGoogle: {
    width: "100%",
    margin: theme.spacing(1),
    backgroundColor: "#c23321 !important",
    color: "white !important"
  }
}));
